<template>
  <div class="brain-hero">
    <img
      src="/assets/branding/start-hero.png"
      alt="메타인지 수학 테스트 대표 이미지"
      class="brain-hero__image"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  compact?: boolean
}>()
</script>

<style scoped>
.brain-hero {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.brain-hero__image {
  width: 100%;
  max-width: 280px;
  height: auto;
  display: block;
  object-fit: contain;
}
</style>